import {AfterViewInit, Directive, ElementRef, Input, Renderer2} from '@angular/core';

@Directive({
    selector: 'iframe[appHideGiphyOverlay]'
})
export class HideGiphyOverlayDirective implements AfterViewInit {
    private condition: boolean = false;
    private iframe!: HTMLIFrameElement;

    constructor(private el: ElementRef, private renderer: Renderer2) {
    }

    @Input() set showOverlay(condition: boolean) {
        this.condition = condition;
        if (this.iframe) {
            this.disableOverlay();
        }
    }

    ngAfterViewInit(): void {
        this.iframe = this.el.nativeElement as HTMLIFrameElement;
        this.disableOverlay();
    }

    private disableOverlay(): void {
        const parent: HTMLIFrameElement = this.iframe;
        if (this.iframe.src.toLowerCase().includes('giphy') && !this.condition) {
            this.renderer.setStyle(parent, 'pointer-events', 'none');
        } else {
            this.renderer.setStyle(parent, 'pointer-events', 'auto');
        }
    }
}
